import { SectionWrapper } from 'components/atoms/SectionWrapper.style';
import React from 'react';
import EleHeader from 'components/organisms/header/EleHeader';
import EleOfferImages from 'components/organisms/electroComponents/eleOfferImg/EleOfferImg';
import EleFarmDesc from 'components/organisms/electroComponents/eleFarmDesc/EleFarmDesc';
import EleCounterWrapper from 'components/organisms/electroComponents/EleCounters/EleCounterWrapper';
import ElePortofilio from 'components/molecules/Portoflio /ElePortofilio';
import Partners from 'components/molecules/Partners/Partners';

const EleOffer = () => (
  <>
    <EleHeader />
    <EleOfferImages />
    {/* <UnderHeader /> */}
    <SectionWrapper>
      <EleFarmDesc />
    </SectionWrapper>
    {/* <ElePortofilio /> */}
    <EleCounterWrapper />
  </>
);

export default EleOffer;
